import axios from "axios";
import jwt_decode from "jwt-decode";

import { logout } from "../components/app-header/UserProfile/UserProfile.utils";

const instance = axios.create({});

instance?.interceptors?.request?.use((config) => {
  const jwtToken = JSON.parse(localStorage.getItem("loginResponse"))?.object?.jwt;
  const userId = JSON.parse(localStorage.getItem("loginResponse"))?.object?.username;
  const sessionTokenResponse = JSON.parse(JSON.stringify(jwt_decode(jwtToken)));
  const tenantId = localStorage.getItem("tenantId");
  const applicationName = localStorage.getItem("applicationName");
  const userRoles = sessionTokenResponse?.userRoles ?? [];
  const subscriptionKey = sessionTokenResponse?.subscriptionKey ?? "";
  const productCategory = sessionStorage.getItem("productCategory") ?? "";
  config.headers.common["Authorization"] = jwtToken;
  config.headers.common["userID"] = userId;
  config.headers.common["Accept-Language"] = "en";
  config.headers.common["Accept"] = "application/json";
  config.headers.common["tenantID"] = tenantId;
  config.headers.common["userRoles"] = userRoles;
  config.headers.common["Ocp-Apim-Subscription-Key"] = subscriptionKey;
  config.headers.common["applicationName"] = applicationName;
  config.headers.common["productCategory"] = productCategory;
  return config;
});

instance?.interceptors?.response?.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);
export default instance;
